import service from "./service"

const submitBackgroundCheckForm = async (data) => {
    return service(data)
}

export default submitBackgroundCheckForm
